const funcNav = (() => {



  let body = document.querySelector('body');
  let nav = document.getElementById('jsNav');
  let navBtn = document.getElementById('jsNavBtn');


  navBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (navBtn.classList.contains('act') == true) {
      body.classList.remove('hidden');
      nav.classList.remove('act');
      navBtn.classList.remove('act');
    } else {
      body.classList.add('hidden');
      nav.classList.add('act');
      navBtn.classList.add('act');
    }
  });



})();
export default funcNav;